export default __webpack_public_path__ + "static/media/map-dark.c24f06d0.png";